/* src/app/location-users/location-user-grid/user-header/user-header.component.scss */
.user {
  min-width: 275px;
  padding: 9px 11px 9px 11px;
  font-weight: normal;
  line-height: 1em;
  display: flex;
  flex-wrap: wrap;
}
.user > div {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.user .remove-user {
  display: flex;
  justify-content: right;
}
a {
  text-decoration: underline;
  color: #426DA9;
  font-size: 14px;
}
.filtered {
  text-decoration: none;
  font-weight: bold;
  color: inherit;
}
.bold {
  font-weight: bold;
}
/*# sourceMappingURL=user-header.component.css.map */
